var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37744 2.75109V10.6238C3.37744 10.9718 3.51568 11.3056 3.76175 11.5516C4.00782 11.7977 4.34157 11.9359 4.68956 11.9359H9.93805C10.286 11.9359 10.6198 11.7977 10.8659 11.5516C11.1119 11.3056 11.2502 10.9718 11.2502 10.6238V4.87803C11.2501 4.70323 11.2152 4.5302 11.1474 4.36909C11.0796 4.20798 10.9802 4.06205 10.8552 3.93987L8.68038 1.81292C8.43525 1.57323 8.10604 1.43901 7.76321 1.43896H4.68956C4.34157 1.43896 4.00782 1.57721 3.76175 1.82328C3.51568 2.06935 3.37744 2.40309 3.37744 2.75109V2.75109Z",
    stroke: "#572148",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62517 11.9359V13.248C8.62517 13.596 8.48693 13.9298 8.24085 14.1758C7.99478 14.4219 7.66104 14.5601 7.31305 14.5601H2.06456C1.71657 14.5601 1.38282 14.4219 1.13675 14.1758C0.890682 13.9298 0.752441 13.596 0.752441 13.248V6.03136C0.752441 5.68336 0.890682 5.34962 1.13675 5.10355C1.38282 4.85748 1.71657 4.71924 2.06456 4.71924H3.37668",
    stroke: "#572148",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.9e73b799d97d2065151f7377f21e1b56.svg";
export { ForwardRef as ReactComponent };